export default "__VITE_ASSET__DUVqAjkp__"